import { render } from "./ggjxgrycgbdDetail.vue?vue&type=template&id=5de38fbc&scoped=true&ts=true"
import script from "./ggjxgrycgbdDetail.vue?vue&type=script&lang=ts"
export * from "./ggjxgrycgbdDetail.vue?vue&type=script&lang=ts"

import "./ggjxgrycgbdDetail.vue?vue&type=style&index=0&id=5de38fbc&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de38fbc"]])

export default __exports__